import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
  GET_USER,
  GET_USER_DETAILS,
  ADD_NEW_USER,
  UPDATE_USER,
  DELETE_USER,
  UPDATE_PW_USER,
} from "./actionTypes";

import {
  getUserSuccess,
  getUserFail,
  getUserDetailsSuccess,
  getUserDetailsFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  updatePwUserSuccess,
  updatePwUserFail,
} from "./actions"

import {
  userListingApi,
  userDetailsApi,
  addNewUser,
  updateUser,
  delUser,
  updatePWUser,
} from "./userApi.js"

function* fetchUser({ payload: length, sort, page, role, sortBy, name}) {
  try {
    const response = yield call(userListingApi, length, sort, page, role, sortBy, name)
    yield put(getUserSuccess(response))
  } catch (error) {
    yield put(getUserFail(error))
  }
}

function* fetchUserDetails({ payload: length, page }) {
  try {
    const response = yield call(userDetailsApi, length, page)
    yield put(getUserDetailsSuccess(response))
  } catch (error) {
    yield put(getUserDetailsFail(error))
  }
}

function* onAddNewUser({ payload: user }) {
  try {
    const response = yield call(addNewUser, user)
    yield put(addUserSuccess(response))
  } catch (error) {
    yield put(addUserFail(error))
  }
}

function* onUpdateUser({ payload: id, user }) {
  try {
    const response = yield call(updateUser, id, user)
    yield put(updateUserSuccess(response))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onDelUser({ payload: id }) {
  try {
    const response = yield call(delUser, id)
    yield put(deleteUserSuccess(response))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onUpdatePWUser({ payload: id, user }) {
  try {
    const response = yield call(updatePWUser, id, user)
    yield put(updatePwUserSuccess(response))
  } catch (error) {
    yield put(updatePwUserFail(error))
  }
}

function* UserSaga() {
  yield takeEvery(GET_USER, fetchUser)
  yield takeEvery(GET_USER_DETAILS, fetchUserDetails)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDelUser)
  yield takeEvery(UPDATE_PW_USER, onUpdatePWUser)

}

export default UserSaga
